import { render, staticRenderFns } from "./homeView2.vue?vue&type=template&id=4790f90a&scoped=true&"
import script from "./homeView2.vue?vue&type=script&lang=js&"
export * from "./homeView2.vue?vue&type=script&lang=js&"
import style0 from "./homeView2.vue?vue&type=style&index=0&id=4790f90a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790f90a",
  null
  
)

export default component.exports